import React, {useCallback, useMemo, useRef, useState} from 'react';
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import axios from "axios";
import projectUtils from "../../../../utils/project-utils.js";

const API_URL = import.meta.env.VITE_API_URL;

const VmsModal = ({vmsModal, data, setVmsModal}) => {
    const gridRef = useRef(null);

    const [columnDefs,] = useState([{
        headerName: "Nome", field: "vmsCorporationName", flex: 1,
        cellRenderer: ({data, value}) => {
            if (value) return value

            return data.vmsUrl
        }
    }])

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    const onRowClicked = useCallback(({data}) => {
        const target = vmsModal.target === "camera" ? 'access-from-video-camera' : 'access-from-collection-system';

        const vmsTab = window.open("", "_blank");
        vmsTab.opener = null;
        axios.get(`${API_URL}/vms/${target}/${data.id}`)
            .then(({data}) => vmsTab.location.href = data)
            .catch(() => {
                vmsTab.close();
                projectUtils.swalErrorMessage("", "Não foi possível abrir o VMS.", "Ok");
            })
    }, [vmsModal.target]);

    const closeModal = () => setVmsModal({open: false, target: "camera"});

    return (
        <>
            <Modal alignTop={true} open={vmsModal.open} setOpen={closeModal} overflow={true} isCloseClick={false} keyboard={false} title={"Selecione um VMS para continuar"} className={"w-4/12"}>
                <Modal.Body className="p-2">

                    <div className={`aggrid-row-pointer`} style={{maxHeight: 'calc(100vh - 222px)'}}>
                        <AgGridReact
                            ref={gridRef}
                            rowData={data ?? []}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            animateRows={false}
                            suppressCellFocus={true}
                            gridOptions={{localeText: aggridUtils.localization()}}
                            onRowClicked={onRowClicked}
                            theme={aggridUtils.generalTheme()}
                            domLayout='autoHeight'
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default VmsModal;
